import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { baseUrl, handleDownload, eqUrlEdit } from "../../Services/Constants";
import { processAndUpdateToken } from "../../Services/CommonFunctions";
import {
  Box,
  Button,
  Card,
  Typography,
  Container,
  Tooltip,
  Table,
  Snackbar,
  Alert,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  InputBase,
  CircularProgress,
} from "@mui/material";
import jwtDecode from "jwt-decode";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import EditIcon from "@mui/icons-material/Edit";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import {
  buildProposalService,
  saveProposalService,
} from "../../Services/ProposalBuilderService";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import MinimizeIcon from "@mui/icons-material/Minimize";
import RefreshIcon from "@mui/icons-material/Refresh";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GetAllProposalQCJobs = () => {
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [isUploadMode, setIsUploadMode] = useState(false);
  const [openPreview, setOpenPreview] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isBuilding, setIsBuilding] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isBackLocked, setIsBackLocked] = useState(false);
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [buildSuccess, setBuildSuccess] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [rowToGenerate, setRowToGenerate] = useState(null);
  const [skipDeleteCheck, setSkipDeleteCheck] = useState(false);
  const [openEyeQ, setOpenEyeQ] = useState(false);
  const [eyeQUrl, setEyeQUrl] = useState("");
  const [isMaximized, setIsMaximized] = useState(false);
  const [deleteData, setDeleteData] = useState({
    brokerId: null,
    fileName: "",
  });

  let url = new URL(window.location.href);
  let urlParamToken = url?.searchParams.get("token");
  const urlParamEyeQToken = url?.searchParams.get("token");
  const decode_UserName = jwtDecode(urlParamToken || "");
  const csrQuoteAuthUserName = decode_UserName?.preferred_username;
  const isTableLoading = isSaving || isBuilding || isDeleting || isRefreshing;

  const targetLobs = [
    "commercial package",
    "homeowners",
    "business owners policy",
    "package",
  ];

  useEffect(() => {
    const initialize = async () => {
      const isAuthorized = await quoteProposalBuilderAuthTokenApi();

      if (isAuthorized) {
        await getAllProposals(csrQuoteAuthUserName);
      }
    };

    initialize();
  }, []);

  const quoteProposalBuilderAuthTokenApi = async () => {
    try {
      if (csrQuoteAuthUserName != undefined) {
        sessionStorage.setItem("csrQuoteAuthUserName", csrQuoteAuthUserName);
        const dataForcsrValidata = {
          csrName: csrQuoteAuthUserName,
          token: urlParamToken,
        };

        let csrView_UserName = await new Promise((resolve, reject) => {
          axios
            .post(
              `${baseUrl}/api/Authentication/QuoteProposalUserValidate`,
              dataForcsrValidata,
              {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              },
            )
            .then((response) => {
              if (response.data == false) {
                if (
                  location?.pathname?.toLowerCase() === "/createproposalbuilder"
                ) {
                  window.location.href = "/UnAuthorizedUser";
                }
              } else {
                resolve(response.data);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      } else {
        if (location?.pathname?.toLowerCase() === "/createproposalbuilder") {
          window.location.href = "/UnAuthorizedUser";
        }
      }
    } catch (error) {
      if (location?.pathname?.toLowerCase() === "/createproposalbuilder") {
        window.location.href = "/UnAuthorizedUser";
      }
      return error;
    } finally {
      return "success";
    }
  };

  const getAllProposals = async () => {
    setIsRefreshing(true);
    const token = await processAndUpdateToken(sessionStorage.getItem("token"));
    const brokerId = await getBrokerId(csrQuoteAuthUserName, token);

    try {
      const url = `${baseUrl}/api/ProposalBuilder/GetAllClientProposalData/${brokerId}/GetAllClientProposals?userName=${csrQuoteAuthUserName}`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data) {
        setRawData(res.data);

        const formattedData = res.data?.map(client => ({
          TemplateID: client?.TemplateID,
          BrokerId: client?.BrokerId,
          schemaName: client?.DatabaseName,
          ClientName: client?.ClientName,
          CreatedBy: client?.CreatedBy,
          ProposalGenerated: client?.CreatedOn,
          FileName: client?.FileName || null,
          Lobs:
            client?.Jobgroup?.map((job) => ({
              name: job?.Lob,
              isNew: job?.IsNewLob,
            })) || [],
          LobsPreview:
            client?.Jobgroup?.map((job) => ({
              name: job?.Lob,
               LobId: job?.LobID,
              isNew: job?.IsNewLob,
            })) || [],
           JobCodes: client?.Jobgroup?.map(job => job?.JobCode) || [],
          Files: client?.Jobgroup?.map(job => job?.Files) || [],
          CarrierName: client?.Jobgroup?.map(e => e?.Carrier) || [],
          LobSplit: client?.Jobgroup[0]?.lobSplit || false
        }));

        const sortedData = formattedData
          ?.map((item) => ({
            ...item,
            Lobs: item.Lobs
              ? [...item.Lobs].sort((a, b) => a.name.length - b.name.length)
              : [],
          }))
          ?.sort((a, b) => a.ClientName.localeCompare(b.ClientName));

        setTableData(sortedData);
      }
    } catch (e) {
      console.error("API Error:", e);
    } finally {
      setIsRefreshing(false);
    }
  };

  const getBrokerId = async (csrQuoteAuthUserName, token) => {
    const res = await axios.post(
      `${baseUrl}/api/ProposalBuilder/GetClient/GetClientsForBroker`,
      { Email: csrQuoteAuthUserName },
      { headers: { Authorization: `Bearer ${token}` } },
    );

    return res?.data?.brokerId;
  };

  const downloadProposalDocx = async (fileName, brokerId) => {
    const token = await processAndUpdateToken(sessionStorage.getItem("token"));

    try {
      const url = `${baseUrl}/api/ProposalBuilder/GetDownloadUrl/DownloadProposal?fileName=${fileName}&brokerId=${brokerId}&expirationSeconds=3600`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.Url) {
        handleDownload(res?.data?.Url, fileName);
      }
    } catch (e) {
      console.error("API Error:", e);
    } finally {
    }
  };

  const reUploadProposal = async (file, templateId, fileName) => {
    if (!file) return;

    const token = await processAndUpdateToken(sessionStorage.getItem("token"));

    const formData = new FormData();
    formData.append("file", file);

    try {
      const url = `${baseUrl}/api/ProposalBuilder/ReUploadProposalUrl/ReUpload?templateId=${templateId}&fileName=${fileName}`;

      await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Proposal file re-uploaded successfully");
    } catch (error) {
      console.error("ReUpload Error:", error);
      alert("Re-upload failed");
    }
  };

  const DeleteProposal = async (brokerId, fileName) => {
    setIsDeleting(true);
    setOpenWarningDialog(false);

    const token = await processAndUpdateToken(sessionStorage.getItem("token"));

    try {
      const url = `${baseUrl}/api/ProposalBuilder/DeleteProposalFromS3/DeleteProposal?brokerId=${brokerId}&fileName=${fileName}`;

      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setOpenWarningDialog(false);
        setSkipDeleteCheck(true);
        setConfirmDialogOpen(true);
      }

      setDeleteSuccess(true);
    } catch (error) {
      console.error("Delete Error:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handlePreviewOpen = (row) => {
    const lobSplitFlag = row?.LobSplit;
    const filterRows = lobSplitFlag ? row?.LobsPreview?.filter((lob) => targetLobs?.includes(lob?.name?.toLowerCase())): row?.LobsPreview;
    setSelectedRow({...row, LobsPreview: filterRows});
    setOpenPreview(true);
  };

  const handlePreviewClose = () => {
    setOpenPreview(false);
    setSelectedRow(null);
  };

  const handleGenerateProposal = async (row) => {
    const token = await processAndUpdateToken(sessionStorage.getItem("token"));
    setRowToGenerate(row);

    const hasNewLob = row?.Lobs?.some((lob) => lob.isNew);
    // if (hasNewLob && !skipDeleteCheck) {
    //   setDeleteData({
    //     brokerId: row?.BrokerId,
    //     fileName: row?.FileName,
    //   });

    //   setOpenWarningDialog(true);
    //   return;
    // }

    // setSkipDeleteCheck(false);

    try {
      const clientData = rawData?.find(
        (item) => item.ClientName === row.ClientName,
      );

      if (!clientData) return;

      const jobGroups = clientData?.Jobgroup || [];
      const lobSplitFlag = clientData?.Jobgroup[0]?.lobSplit;

      // -----------------------------------------
      const sectionState = {
        0: {
          BrokerId: clientData?.BrokerId,
          ClientName: clientData?.ClientName,
          CreatedBy: clientData?.CreatedBy,
          CoverPage: true,
          TableOfContent: true,
          CommonInformation: true,
          NameInsuredOrSchedule: true,
          PremiumSummary: true,
          CoverageSummary: true,
          Schedule: true,
        },
      };

      // -----------------------------------------
      const sectionStatus = jobGroups?.map((job) => ({
        JobId: job.JobId,
        Lob: job.Lob,
      }));

      setIsSaving(true);
      setIsBackLocked(true);
      try {
        await saveProposalService(sectionState, sectionStatus, lobSplitFlag);
      } catch (error) {
        console.error("Save failed", error);
        setIsBackLocked(false);
      } finally {
        setIsSaving(false);
      }

      // -----------------------------------------
      const targetLobs = [
        "commercial package",
        "homeowners",
        "business owners policy",
        "package",
      ];

     const filterJobGroups = lobSplitFlag ? jobGroups?.filter((row) => !targetLobs?.includes(row?.Lob?.toLowerCase())): jobGroups;

      const buildPayload = (createdBy) => ({
        BrokerId: clientData.BrokerId,
        ClientName: clientData.ClientName,
        LobSplit:
          jobGroups[0]?.lobSplit !== null ? jobGroups[0]?.lobSplit : false,
        CreatedBy: createdBy,
        JobSelections: filterJobGroups?.map((job) => ({
          JobId: job?.JobId,
          LobId: job?.LobID,
          Files: job?.Files?.length > 3 ? job?.Files?.slice(0, 3) : job?.Files,
        })),
      });

      const payloadData = buildPayload(clientData?.CreatedBy);

      try {
        setIsBuilding(true);

        const response = await buildProposalService(payloadData);

        // -----------------------------------------
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        setBuildSuccess(true);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        const fileName = response.headers["proposal-filename"];
        a.href = url;
        a.download = `${fileName}`;

        a.click();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Build Proposal failed", err);
      } finally {
        setIsBuilding(false);
        await getAllProposals(csrQuoteAuthUserName);
      }
    } catch (error) {
      console.error("Generate Proposal Error:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    // Convert to ISO UTC format
    const isoString = dateString.replace(" ", "T") + "Z";

    const date = new Date(isoString);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", {
      month: "short",
      timeZone: "UTC",
    });
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const filteredData = tableData?.filter((row) =>
    row.ClientName?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const statusColorMap = {
    1: { bg: "#FEF3C7", text: "#D97706" },
    2: { bg: "#DBEAFE", text: "#1E40AF" },
    3: { bg: "#DBEAFE", text: "#1E40AF" },
    4: { bg: "#ECFDF5", text: "#047857" },
    5: { bg: "#FEE2E2", text: "#B91C1C" },
    6: { bg: "#DBEAFE", text: "#1D4ED8" },
    7: { bg: "#ECFDF5", text: "#065F46" },
    8: { bg: "#FEE2E2", text: "#DC2626" },
    9: { bg: "#DBEAFE", text: "#2563EB" },
    10: { bg: "#ECFDF5", text: "#059669" },
  };

  return (
    <Box
      sx={{
        bgcolor: "#f4f6f9",
        minHeight: "100vh",
        pt: "20px",
        pb: "80px",
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />

      <Container
        maxWidth={false}
        sx={{
          maxWidth: {
            lg: "1230px",
          },
          px: {
            xs: 2,
            sm: "0px",
          },
          pr: {
            sm: "0px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {/* Search Bar */}
          <Paper
            elevation={0}
            sx={{
              display: "flex",
              alignItems: "center",
              px: 2,
              py: 0.8,
              width: { xs: "100%", sm: "180px" },
              borderRadius: "10px",
              backdropFilter: "blur(12px)",
              background: "rgba(255, 255, 255, 0.65)",
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              border: "1px solid rgba(255,255,255,0.4)",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 10px 28px rgba(0,0,0,0.12)",
              },
              "&:focus-within": {
                boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.15)",
              },
            }}
          >
            <SearchIcon sx={{ color: "#6b7280", mr: 1 }} />

            <InputBase
              fullWidth
              placeholder="Search Client Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                fontSize: "9px",
                margin: "2px 0px 0px 5px",
                color: "#111827",
              }}
            />

            {searchTerm && (
              <IconButton
                size="small"
                onClick={() => setSearchTerm("")}
                sx={{
                  ml: 0.5,
                  color: "#6b7280",
                  "&:hover": { color: "#111827" },
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            )}
          </Paper>

          {/* Refresh Button */}
          <Tooltip title="Refresh Proposals table">
            <IconButton
              onClick={() => getAllProposals(csrQuoteAuthUserName)}
              sx={{
                position: "relative",
                left: "-2px",
                width: 36,
                height: 36,
                borderRadius: "8px",
                backgroundColor: "#ffffff",
                border: "1px solid #e5e7eb",
                boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
                "&:hover": {
                  backgroundColor: "#f9fafb",
                  // transform: "rotate(90deg)",
                  // transition: "all 0.3s ease"
                },
              }}
            >
              <RefreshIcon
                sx={{
                  fontSize: 25,
                  color: "#37415185",
                  "&:hover": {
                    transform: "rotate(90deg)",
                    transition: "all 0.3s ease",
                  },
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>

        {/* TABLE */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: "14px",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            boxShadow: "0 4px 16px rgba(0,0,0,0.04)",
            position: "relative",
          }}
        >
          {isTableLoading && (
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                zIndex: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
              }}
            >
              <CircularProgress size={36} />
              <Typography sx={{ mt: 1, fontSize: "12px", color: "#374151" }}>
                {isSaving
                  ? "Saving proposal configuration..."
                  : isDeleting
                    ? "Deleting proposal..."
                    : isRefreshing
                      ? "Refreshing proposals..."
                      : "Building proposal..."}
              </Typography>
            </Box>
          )}
          <TableContainer
            sx={{
              maxHeight: "70vh",
              width: "100%",
              overflowX: "auto",
            }}
          >
            <Table
              stickyHeader
              sx={{
                minWidth: 950,
                width: "100%",
                borderCollapse: "separate",
                borderSpacing: 0,

                "& th": {
                  fontWeight: 600,
                  fontSize: "11px",
                  backgroundColor: "#f9fafb",
                  color: "#667085",
                  borderBottom: "1px solid #eaecf0",
                  padding: "12px 10px",
                  whiteSpace: "nowrap",
                },

                "& td": {
                  fontSize: "9.5px",
                  padding: "10px 14px",
                  borderBottom: "1px solid #f2f4f7",
                  color: "#344054",
                  verticalAlign: "middle",
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 120 }}>Client Name</TableCell>

                  <TableCell sx={{ width: 120 }}>Line of Business</TableCell>

                  <TableCell sx={{ width: 100 }} align="center">
                    Build
                  </TableCell>

                  <TableCell sx={{ width: 100 }} align="center">
                    Edit
                  </TableCell>

                  <TableCell sx={{ width: 100 }} align="center">
                    Custom Build
                  </TableCell>

                  {/* <TableCell sx={{ width: 100 }} align="center">
                    Timestamp
                  </TableCell> */}

                  <TableCell sx={{ width: 120 }} align="center">
                    Download Proposal
                  </TableCell>

                  <TableCell sx={{ width: 100 }} align="center">
                    Source Information
                  </TableCell>
                  {/* 
                  <TableCell colSpan={2} sx={{ width: 100 }} align="center">
                    Edit
                  </TableCell> */}
                </TableRow>

                {/* <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      minWidth: 40,
                      position: "sticky",
                      top: 21.3,
                      background: "#f8fafc",
                      zIndex: 2
                    }}
                  >
                    IStudio
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      minWidth: 40,
                      position: "sticky",
                      top: 21.3,
                      background: "#f8fafc",
                      zIndex: 2
                    }}
                  >
                    Eye Q
                  </TableCell>
                </TableRow> */}
              </TableHead>

              <TableBody>
                {tableData?.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={4}
                      align="center"
                      sx={{
                        position: "relative",
                        left: "250px",
                        padding: "20px 0",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 500, mb: 1 }}
                        >
                          No Proposals Yet
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#6b7280" }}>
                          Click "Create Proposal" to generate one.
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData?.map((row, index) => {
                     const lobArray = row?.Lobs || [];
                    const lobSplitFlag = row?.LobSplit;
                    const matchedLob = lobSplitFlag ? lobArray?.find((lob) =>
                      targetLobs?.includes(lob?.name?.toLowerCase()),
                    ) : lobArray;
                    const hasNewLob = lobSplitFlag ? matchedLob?.isNew : matchedLob?.some((lob) => lob?.isNew);
                    const result = Array?.isArray(matchedLob) ? matchedLob : [matchedLob];

                    return (
                      <TableRow
                        key={index}
                        // hover
                        sx={{
                          transition: "background 0.2s ease",
                          // "&:hover": {
                          //   // backgroundColor: "#f9fafb",
                          // },
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            fontSize: "9.5px",
                            color: "#101828",
                          }}
                        >
                          {row?.ClientName}
                        </TableCell>

                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                              maxWidth: 200,
                            }}
                          >
                            {result?.map((lob, i) => (
                              <Chip
                                key={i}
                                label={lob?.name?.trim()}
                                size="small"
                                sx={{
                                  backgroundColor:    "#ECFDF3",// lob.isNew  ? "#FEE2E2" : "#ECFDF3",
                                  color: "#027A48", //lob.isNew ? "#B91C1C" : "#027A48",
                                  border: "1px solid #ABEFC6", //lob.isNew  ? "1px solid #FCA5A5"  : "1px solid #ABEFC6",
                                  height: 22,
                                  borderRadius: "12px",
                                  fontWeight: 500,
                                  fontSize: "9.5px",
                                }}
                              />
                            ))}
                          </Box>
                        </TableCell>

                        {/* GENERATE */}
                        <TableCell align="center">
                          <Tooltip title="Click to generate proposal">
                            <IconButton
                              sx={{
                                width: 34,
                                height: 34,
                                borderRadius: "8px",
                                color: "#6b6b6b",
                                backgroundColor: "#6f6b6b29",
                                // "&:hover": {
                                //   backgroundColor: "#e0e0e0",
                                // },
                              }}
                              onClick={() => handleGenerateProposal(row)}
                            >
                              <AutoModeIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>

                        {/* EYE Q */}
                        <TableCell align="center">
                          {row?.ProposalGenerated && (
                            // <Tooltip title={ hasNewLob ? "Can't edit proposal new LOB added" : "Edit Proposal Document" }  arrow >
                            <Tooltip title={ "Edit Proposal Document" }  arrow >
                              <span style={{ display: "inline-flex" }}>
                                <IconButton
                                  // disabled={hasNewLob}
                                  onClick={() => {
                                    const lobArray = row?.Lobs || [];
                                    const lobSplitFlag = row?.LobSplit;
                                    const matchedLob = lobSplitFlag ? lobArray?.find((lob) =>
                                      targetLobs?.includes(lob?.name?.toLowerCase()),
                                    ) : lobArray;
                                    const result = Array?.isArray(matchedLob) ? matchedLob : [matchedLob];
                                    
                                    const lobs = encodeURIComponent(
                                      result?.map((e) => e.name)?.join(", "),
                                    );
                                    const templateId = row?.TemplateID;
                                    const dbName = row?.schemaName;
                                    const fileName = encodeURIComponent(
                                      row?.FileName,
                                    );
                                    const clientName = encodeURIComponent(
                                      row?.ClientName,
                                    );
                                    const schemaCode = row?.BrokerId;

                                    const url = `${eqUrlEdit}/${dbName?.toLowerCase()}/proposal-editor?templateId=${templateId}&fileName=${fileName}&clientName=${clientName}&schemaCode=${schemaCode}&lob=${lobs}&token=${urlParamEyeQToken}`;
                                    // const url = `${eqUrlEdit}/${dbName?.toLowerCase()}/proposal-editor?templateId=${templateId}&fileName=${fileName}&clientName=${clientName}&schemaCode=${schemaCode}&token=${urlParamEyeQToken}`;

                                    setEyeQUrl(url);
                                    setOpenEyeQ(true);
                                  }}
                                  sx={{
                                    width: 34,
                                    height: 34,
                                    borderRadius: "8px",
                                    backgroundColor:  "#6f6b6b29",// hasNewLob ? "#C7C7C7"  : "#6f6b6b29",
                                    opacity: "", //hasNewLob ? 0.6 : "",
                                    cursor: "",  //hasNewLob ? "not-allowed" : "",
                                  }}
                                >
                                  <img
                                    src="/eyeq.png"
                                    alt="Edit Proposal"
                                    style={{
                                      width: 20,
                                      height: 21,
                                      filter: "none", //hasNewLob ? "grayscale(100%) brightness(0.7)": "none",
                                    }}
                                  />
                                </IconButton>
                              </span>
                            </Tooltip>
                          )}
                        </TableCell>

                        {/* ISTUDIO */}
                        <TableCell align="center">
                          {row?.ProposalGenerated && (
                            // <Tooltip title={ hasNewLob ? "Can't edit proposal new LOB added" : "Edit Proposal Configuration" } arrow >
                            <Tooltip title={  "Edit Proposal Configuration" } arrow >
                              <span style={{ display: "inline-flex" }}>
                                <IconButton
                                  // disabled={hasNewLob}
                                  sx={{
                                    width: 34,
                                    height: 34,
                                    borderRadius: "8px",
                                    backgroundColor: "#6f6b6b29",
                                    cursor: "pointer", // hasNewLob? "not-allowed" : "pointer",
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/proposalsections?token=${urlParamToken}`,
                                      {
                                        state: {
                                          editMode: true,
                                          clientName: row.ClientName,
                                          JobCode: row.JobCodes,
                                          files: row.JobCodes.map((code, idx) => ({
                                            JobCode: code,
                                            files: row.Files[idx] || [],
                                            carrier: row.CarrierName[idx] || []
                                          })),
                                          Lobs: row.Lobs,
                                          lobSplitFlag: row?.LobSplit,
                                          lobEditData: row,
                                          CreatedBy: row?.CreatedBy
                                        },
                                      },
                                    )
                                  }
                                >
                                  <EditIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                              </span>
                            </Tooltip>
                          )}
                        </TableCell>

                        {/* DOWNLOAD */}
                        <TableCell align="center">
                          {row?.ProposalGenerated && (
                            <Tooltip title="Download in Word" arrow>
                              <IconButton
                                sx={{
                                  width: 34,
                                  height: 34,
                                  borderRadius: "8px",
                                  backgroundColor: "#6f6b6b29",
                                }}
                                onClick={() =>
                                  downloadProposalDocx(
                                    row?.FileName,
                                    row?.BrokerId,
                                  )
                                }
                              >
                                <img
                                  src="/wordimage.png"
                                  alt="Word"
                                  style={{
                                    width: 30,
                                    height: 27,
                                  }}
                                />
                              </IconButton>

                              {/* <Button
                                onClick={() =>
                                  downloadProposalDocx(
                                    row?.FileName,
                                    row?.BrokerId
                                  )
                                }
                                startIcon={
                                  <img
                                    src="/wordimage.png"
                                    alt="Word"
                                    style={{
                                      width: 22,
                                      height: 22,
                                    }}
                                  />
                                }
                                sx={{
                                  background: "linear-gradient(135deg, #38529d, #38529d)",
                                  color: "#fff",
                                  textTransform: "none",
                                  borderRadius: "6px",
                                  // px: 3,
                                  // py: 1,
                                  pl: "4px",
                                  pr: "8px",
                                  pt: "2px",
                                  pb: '2px',
                                  fontWeight: 600,
                                  fontSize: "8px",
                                  transition: "all 0.3s ease",
                                  "&:hover": {
                                    // background: "linear-gradient(135deg, #38529d, #38529d)",
                                    // boxShadow: "0 6px 16px rgba(28,109,208,0.4)",
                                    // transform: "translateY(-2px)",
                                  },
                                  "& .MuiButton-startIcon": {
                                    marginRight: "2px",
                                    marginLeft: "0px",
                                  },
                                }}
                              >
                                Word
                              </Button> */}
                            </Tooltip>
                          )}
                        </TableCell>

                        {/* DATE */}
                        {/* <TableCell align="center"
                          sx={{
                            fontWeight: 500,
                            verticalAlign: "middle",
                            fontSize: "9.5px",
                          }}
                        >
                          <Box component="span" sx={{ color: "#1570EF" }}>
                            {formatDate(row?.ProposalGenerated)}
                          </Box> */}

                        {/* {row?.ProposalGenerated && (
                            <Box
                              component="span"
                              sx={{
                                color: "#dc2626",
                                ml: "3px",
                                fontWeight: "bolder",
                                fontSize: "10px",
                              }}
                            >
                              *
                            </Box>
                          )} */}
                        {/* </TableCell> */}

                        {/* DETAILS */}
                        <TableCell
                          align="center"
                          sx={
                            {
                              // borderRight: "1px solid #e5e7eb"
                            }
                          }
                        >
                          <Tooltip title="Source Documents">
                            <IconButton
                              sx={{
                                width: 34,
                                height: 34,
                                borderRadius: "8px",
                                backgroundColor: "#6f6b6b29",
                              }}
                              onClick={() => handlePreviewOpen(row)}
                            >
                              {/* <MoreHorizIcon sx={{ fontSize: 18 }} /> */}
                              <img
                                src="/source_info.jpg"
                                alt="source_info"
                                style={{
                                  width: 25,
                                  height: 22,
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Dialog
          open={openEyeQ}
          onClose={() => setOpenEyeQ(false)}
          fullScreen={isMaximized}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              zoom: "60%",
              width: isMaximized ? "100%" : "85%",
              height: isMaximized ? "100%" : "85%",
              borderRadius: "12px",
              overflow: "hidden",
              position: "relative",
            },
          }}
        >
          {/* FLOATING ACTION BUTTONS */}
          <Box
            sx={{
              position: "static",
              // top: isMaximized ? 0 : "clamp(8px, 4vh, 28px)",
              // right: isMaximized ? 15 : "8.5%",
              justifyContent: "end",
              zIndex: 1301,
              display: "flex",
              gap: 0.5,
            }}
          >
            {[
              { label: "−", onClick: () => setIsMaximized(false) },
              { label: "□", onClick: () => setIsMaximized(true) },
            ].map((btn, i) => (
              <IconButton
                key={i}
                onClick={btn.onClick}
                size="small"
                sx={{
                  width: 26,
                  height: 26,
                  backgroundColor: "rgba(255,255,255,0.7)",
                  borderRadius: "50px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                  color: "#333",
                  fontSize: "14px",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.9)",
                  },
                }}
              >
                <span style={{ position: "relative", top: -2, fontSize: 16 }}>
                  {btn.label}
                </span>
              </IconButton>
            ))}

            <IconButton
              onClick={() => setOpenEyeQ(false)}
              size="small"
              sx={{
                width: 26,
                height: 26,
                backgroundColor: "rgba(255,255,255,0.7)",
                borderRadius: "50px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                color: "#d32f2f",
                "&:hover": {
                  backgroundColor: "rgba(255,0,0,0.15)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>

          {/* CONTENT */}
          <DialogContent sx={{ p: 0, height: "100%" }}>
            <iframe
              src={eyeQUrl}
              title="EyeQ Editor"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={openPreview}
          onClose={handlePreviewClose}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "16px",
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              borderBottom: "1px solid #eef2f7",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 3,
              py: 2,
            }}
          >
            Source Details
            {selectedRow?.ProposalGenerated && (
              <Box sx={{ fontSize: "13px", color: "#475569" }}>
                <b style={{ color: "#111827" }}>GeneratedOn:</b>{" "}
                <span
                  style={{
                    color: "#2563eb",
                    fontWeight: 500,
                    fontSize: "12px",
                  }}
                >
                  {formatDate(selectedRow?.ProposalGenerated)}
                </span>
              </Box>
            )}
          </DialogTitle>

          <DialogContent sx={{ mt: 1.5 }}>
            {selectedRow && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                {/* CLIENT + FILE CARD */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 3,
                    backgroundColor: "#ffffff",
                    p: 2.5,
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{ fontSize: "13px", color: "#64748b", mb: 0.5 }}
                    >
                      Client Name
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "15px",
                        color: "#0f172a",
                      }}
                    >
                      {selectedRow?.ClientName}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{ fontSize: "13px", color: "#64748b", mb: 0.5 }}
                    >
                      File Name
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#1e293b",
                        wordBreak: "break-word",
                      }}
                    >
                      {selectedRow.FileName}
                    </Typography>
                  </Box>
                </Box>

                {/* SECTION TITLE */}
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#1e293b",
                    mt: 1,
                  }}
                >
                  LOB • JobCodes • QuoteFiles
                </Typography>

                {/* LOBS LIST */}
                {selectedRow?.LobsPreview?.map((lob, index) => {
                  const jobCode = selectedRow?.JobCodes?.[index] || "-";
                  const files = selectedRow?.Files?.[index] || [];
                  const carrierMap = selectedRow?.CarrierName?.[index] || {};
                  const normalizedCarrierMap = Object.fromEntries(
                    Object.entries(carrierMap).map(([key, value]) => [
                      key.toLowerCase(),
                      value,
                    ]),
                  );

                  return (
                    <Box
                      key={index}
                      sx={{
                        backgroundColor: "#ffffff",
                        p: 2.5,
                        borderRadius: "12px",
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.05)",
                        transition: "0.2s",
                        "&:hover": {
                          boxShadow: "0 10px 22px rgba(0,0,0,0.08)",
                        },
                      }}
                    >
                      {/* HEADER */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 1.5,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "15px",
                            color: "#0f172a",
                          }}
                        >
                          {lob?.name?.trim()}
                        </Typography>

                        <Box
                          sx={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "#1d4ed8",
                            backgroundColor: "#dbeafe",
                            px: 1.5,
                            py: 0.5,
                            borderRadius: "999px",
                          }}
                        >
                          {jobCode}
                        </Box>
                      </Box>

                      {/* FILE LIST */}
                      <Box sx={{ pl: 1 }}>
                        {files.length > 0 ? (
                          files.map((file, i) => {
                            const carrier =
                              normalizedCarrierMap?.[file?.toLowerCase()];

                            return (
                              <Typography
                                key={i}
                                sx={{
                                  fontSize: "13px",
                                  color: "#334155",
                                  display: "flex",
                                  gap: 1,
                                  mb: 0.6,
                                  lineHeight: 1.5,
                                }}
                              >
                                •
                                <span>
                                  {file}
                                  {carrier &&
                                    carrier !==
                                      "Details not available in the document" && (
                                      <Box
                                        component="span"
                                        sx={{
                                          fontWeight: 600,
                                          color: "#0f172a",
                                          ml: 0.5,
                                        }}
                                      >
                                        [{carrier}]
                                      </Box>
                                    )}
                                </span>
                              </Typography>
                            );
                          })
                        ) : (
                          <Typography
                            sx={{ fontSize: "13px", color: "#94a3b8" }}
                          >
                            No files available
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button
              onClick={handlePreviewClose}
              variant="contained"
              sx={{
                backgroundColor: "#2563eb",
                borderRadius: "8px",
                textTransform: "none",
                "&:hover": { backgroundColor: "#1d4ed8" },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={confirmDialogOpen}
          onClose={() => setConfirmDialogOpen(false)}
          PaperProps={{
            sx: {
              borderRadius: "20px",
              p: 4,
              textAlign: "center",
              maxWidth: "420px",
            },
          }}
        >
          {/* Close */}
          <IconButton
            onClick={() => setConfirmDialogOpen(false)}
            sx={{
              position: "absolute",
              right: 12,
              top: 12,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Icon Circle */}
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "#9da3b02b",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 15px",
            }}
          >
            <Typography
              sx={{
                position: "relative",
                borderRadius: "8px",
                color: "#6b6b6bc7",
                backgroundColor: "#f1f1f1",
              }}
            >
              <AutoModeIcon
                sx={{
                  fontSize: 27,
                  position: "relative",
                  top: "1.9px",
                  left: "0.9px",
                }}
              />
            </Typography>
          </Box>

          {/* Title */}
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: 22,
              mb: 1,
            }}
          >
            Generate Proposal!
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: 14,
              color: "#6b7280",
              mb: 3,
            }}
          >
            Click generate to create the new proposal
          </Typography>

          {/* Buttons */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              fullWidth
              onClick={() => setConfirmDialogOpen(false)}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                color: "#555",
                border: "0.1px solid #0000000f",
                borderRadius: "8px",
              }}
            >
              Cancel
            </Button>

            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                setConfirmDialogOpen(false);
                handleGenerateProposal(rowToGenerate);
              }}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                background: "linear-gradient(135deg, #676c75ab, #b5b5b5)",
                boxShadow: "none",
                "&:hover": {
                  background: "linear-gradient(135deg, #676c75ab, #b5b5b5)",
                  boxShadow: "none",
                },
                "&:focus": {
                  boxShadow: "none",
                },
                "&:active": {
                  boxShadow: "none",
                  background: "linear-gradient(135deg, #676c75ab, #b5b5b5)",
                },
              }}
            >
              Generate
            </Button>
          </Box>
        </Dialog>

        <Dialog
          open={openWarningDialog}
          onClose={() => setOpenWarningDialog(false)}
          PaperProps={{
            sx: {
              borderRadius: "16px",
              pt: "50px",
              pb: "28px",
              pr: "20px",
              pl: "20px",
              textAlign: "center",
              position: "relative",
              maxWidth: "500px",
              overflow: "visible",
              boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            },
          }}
        >
          {/* Top Circle */}
          <Box
            sx={{
              position: "absolute",
              top: "-57px",
              left: "50%",
              transform: "translateX(-50%)",
              width: 125,
              height: 115,
              borderRadius: "50%",
              background:
                "linear-gradient(to bottom, #ffffff00 50%, #F3F4F6 50%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DeleteOutlineIcon
              sx={{
                position: "absolute",
                top: "60px",
                left: "42px",
                fontSize: 40,
                color: "#FF3B3B",
              }}
            />
          </Box>

          {/* Close */}
          <IconButton
            onClick={() => setOpenWarningDialog(false)}
            sx={{
              position: "absolute",
              right: 12,
              top: 12,
              color: "#BDBDBD",
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Title */}
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "22px",
              color: "#333",
              mt: 2,
            }}
          >
            New Line of Business is added
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              mt: 2,
              fontSize: "17px",
              color: "#8A8A8A",
              lineHeight: 1.6,
            }}
          >
            Delete existing generated proposal for this client is required.
            <br />
            Click Delete!
          </Typography>

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 2,
            }}
          >
            <Button
              onClick={() => setOpenWarningDialog(false)}
              sx={{
                width: "20%",
                textTransform: "none",
                fontWeight: 500,
                color: "#555",
                border: "0.1px solid #0000000f",
                borderRadius: "8px",
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() =>
                DeleteProposal(deleteData?.brokerId, deleteData?.fileName)
              }
              sx={{
                backgroundColor: "#FF3B3B",
                textTransform: "none",
                borderRadius: "8px",
                px: 3,
                fontWeight: 600,
                boxShadow: "0 6px 16px rgba(255,59,59,0.35)",
                "&:hover": {
                  backgroundColor: "#E52E2E",
                },
              }}
            >
              Delete
            </Button>
          </Box>
        </Dialog>

        <Snackbar
          open={buildSuccess}
          autoHideDuration={4000}
          onClose={() => setBuildSuccess(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setBuildSuccess(false)}
            severity="success"
            variant="filled"
            sx={{
              backgroundColor: "rgb(22 163 74)",
              color: "#fff",
              fontWeight: 500,
              borderRadius: "8px",
            }}
          >
            Proposal configuration saved & built successfully.
          </Alert>
        </Snackbar>

        <Snackbar
          open={deleteSuccess}
          autoHideDuration={4000}
          onClose={() => setDeleteSuccess(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setDeleteSuccess(false)}
            severity="success"
            variant="filled"
            sx={{
              backgroundColor: "rgb(22 163 74)",
              color: "#fff",
              fontWeight: 500,
              borderRadius: "8px",
            }}
          >
            Proposal deleted successfully.
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
};

export default GetAllProposalQCJobs;
